var _style, _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonFotocam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 270",
    style: {
      enableBackground: "new 0 0 270 270"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#50AED4;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000137116348954612242770000011560648826621364135_);}\n\t.st4{fill:#59595C;}\n\t.st5{fill:url(#SVGID_00000155145867450832841200000000740053095272006564_);}\n\t.st6{fill:url(#SVGID_00000092433018902159562760000003098169855002646974_);}\n\t.st7{opacity:0;fill:#FFFFFF;}\n\t.st8{opacity:3.225806e-02;fill:#F9F9F9;}\n\t.st9{opacity:6.451613e-02;fill:#F3F3F3;}\n\t.st10{opacity:9.677419e-02;fill:#EDEDED;}\n\t.st11{opacity:0.129;fill:#E7E6E7;}\n\t.st12{opacity:0.1613;fill:#E1E0E1;}\n\t.st13{opacity:0.1935;fill:#DADADB;}\n\t.st14{opacity:0.2258;fill:#D4D4D5;}\n\t.st15{opacity:0.2581;fill:#CECECE;}\n\t.st16{opacity:0.2903;fill:#C8C8C8;}\n\t.st17{opacity:0.3226;fill:#C2C2C2;}\n\t.st18{opacity:0.3548;fill:#BCBCBC;}\n\t.st19{opacity:0.3871;fill:#B6B5B6;}\n\t.st20{opacity:0.4194;fill:#B0AFB0;}\n\t.st21{opacity:0.4516;fill:#AAA9AA;}\n\t.st22{opacity:0.4839;fill:#A4A3A4;}\n\t.st23{opacity:0.5161;fill:#9D9D9E;}\n\t.st24{opacity:0.5484;fill:#979798;}\n\t.st25{opacity:0.5806;fill:#919192;}\n\t.st26{opacity:0.6129;fill:#8B8B8C;}\n\t.st27{opacity:0.6452;fill:#858486;}\n\t.st28{opacity:0.6774;fill:#7F7E80;}\n\t.st29{opacity:0.7097;fill:#79787A;}\n\t.st30{opacity:0.7419;fill:#737274;}\n\t.st31{opacity:0.7742;fill:#6D6C6D;}\n\t.st32{opacity:0.8065;fill:#676667;}\n\t.st33{opacity:0.8387;fill:#606061;}\n\t.st34{opacity:0.871;fill:#5A5A5B;}\n\t.st35{opacity:0.9032;fill:#545355;}\n\t.st36{opacity:0.9355;fill:#4E4D4F;}\n\t.st37{opacity:0.9677;fill:#484749;}\n\t.st38{fill:#424143;}\n\t.st39{fill:#F79D00;}\n\t.st40{fill:url(#SVGID_00000023960694679020599490000011476247534185614978_);}\n\t.st41{fill:url(#SVGID_00000160152783580042465940000012841926159342641319_);}\n\t.st42{opacity:0.14;fill:#FFFFFF;}\n\t.st43{opacity:0.28;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,135c0,74.6-60.4,135-135,135C60.4,270,0,209.6,0,135C0,60.4,60.4,0,135,0C209.6,0,270,60.4,270,135z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.7,135c0,71.6-58.1,129.7-129.7,129.7C63.4,264.7,5.3,206.6,5.3,135C5.3,63.4,63.4,5.3,135,5.3 C206.6,5.3,264.7,63.4,264.7,135z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.9082,
    y1: 135,
    x2: 260.0918,
    y2: 135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#725ECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002755152,
    style: {
      stopColor: "#7260CD",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06290876,
    style: {
      stopColor: "#7C7FBA",
      stopOpacity: 0.9367
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    style: {
      stopColor: "#849AA9",
      stopOpacity: 0.8696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2064,
    style: {
      stopColor: "#8AB09C",
      stopOpacity: 0.7924
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#8FC192",
      stopOpacity: 0.7023
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#92CC8A",
      stopOpacity: 0.5907
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5626,
    style: {
      stopColor: "#94D386",
      stopOpacity: 0.4343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.1,135c0,69.1-56,125.1-125.1,125.1c-69.1,0-125.1-56-125.1-125.1C9.9,65.9,65.9,9.9,135,9.9 C204.1,9.9,260.1,65.9,260.1,135z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085232743364835553410000001491830159741805225_",
    gradientUnits: "userSpaceOnUse",
    x1: 3577.6223,
    y1: -10032.2236,
    x2: 3827.8059,
    y2: -10032.2236,
    gradientTransform: "matrix(-0.8755 0.4832 -0.4832 -0.8755 -1471.2775 -10437.3916)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2FFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#AAF8EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    style: {
      stopColor: "#94E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    style: {
      stopColor: "#70C8DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50AED4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085232743364835553410000001491830159741805225_)"
    },
    d: "M25.5,195.5 C-7.9,135,14.1,58.9,74.6,25.5c60.5-33.4,136.6-11.4,170,49.1c33.4,60.5,11.4,136.6-49.1,170C135,277.9,58.9,255.9,25.5,195.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228.1,121.7c0,52.5-37.6,102.5-90.1,102.5c-52.5,0-93.5-33.3-93.5-85.7c0-52.5,43.6-96.9,96.1-96.9 S228.1,69.3,228.1,121.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008848879092371489590000008673895761343355052_",
    cx: 251.0983,
    cy: -7.0384,
    r: 591.0645,
    gradientTransform: "matrix(0.7427 0 0 0.7427 34.8211 34.6274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008848879092371489590000008673895761343355052_)"
    },
    d: "M241.5,135 c0,58.8-47.7,106.5-106.5,106.5c-58.8,0-106.5-47.7-106.5-106.5C28.5,76.2,76.2,28.5,135,28.5 C193.8,28.5,241.5,76.2,241.5,135z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000122700908197817118800000010937553485195181241_",
    cx: 19.1767,
    cy: 261.2225,
    r: 330.3981,
    gradientTransform: "matrix(0.7427 0 0 0.7427 34.8211 34.6274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122700908197817118800000010937553485195181241_)"
    },
    d: "M236.2,135 c0,55.9-45.3,101.2-101.2,101.2S33.8,190.9,33.8,135C33.8,79.1,79.1,33.8,135,33.8S236.2,79.1,236.2,135z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.4,140.7c0,53.7-41.5,91.8-95.1,91.8c-53.7,0-90.8-53.9-86.3-98.6c4.5-44.7,35.7-81.3,89.4-81.3 C182.1,52.6,220.4,87,220.4,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M220.1,140.2c0,53.3-41.1,91.5-94.4,91.5c-53.3,0-90.3-53-85.9-97.6c4.4-44.6,35.7-81.2,89-81.2 C182,52.9,220.1,86.9,220.1,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219.7,139.8c0,53-40.7,91.2-93.7,91.2c-53,0-89.8-52.1-85.6-96.7c4.2-44.5,35.7-81.1,88.6-81.1 C182,53.2,219.7,86.8,219.7,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M219.4,139.3c0,52.6-40.4,90.9-93,90.9c-52.6,0-89.3-51.3-85.3-95.7c4.1-44.5,35.7-81,88.3-81 C182,53.5,219.4,86.7,219.4,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M219,138.9c0,52.2-40,90.6-92.3,90.6c-52.2,0-88.8-50.4-84.9-94.8c3.9-44.4,35.7-80.9,87.9-80.9 C181.9,53.8,219,86.6,219,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218.6,138.4c0,51.9-39.7,90.3-91.6,90.3c-51.9,0-88.3-49.5-84.6-93.8c3.8-44.3,35.6-80.8,87.5-80.8 C181.9,54.1,218.6,86.6,218.6,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M218.3,138c0,51.5-39.3,90.1-90.8,90.1c-51.5,0-87.9-48.7-84.2-92.9c3.6-44.2,35.6-80.7,87.1-80.7 C181.9,54.4,218.3,86.5,218.3,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M217.9,137.5c0,51.1-39,89.8-90.1,89.8c-51.1,0-87.4-47.8-83.9-92c3.5-44.2,35.6-80.6,86.8-80.6 C181.8,54.7,217.9,86.4,217.9,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M217.6,137.1c0,50.8-38.6,89.5-89.4,89.5c-50.8,0-86.9-46.9-83.5-91C48,91.5,80.2,55,131,55 C181.8,55,217.6,86.3,217.6,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M217.2,136.6c0,50.4-38.3,89.2-88.7,89.2c-50.4,0-86.4-46.1-83.2-90.1c3.2-44,35.6-80.4,86-80.4 C181.7,55.3,217.2,86.2,217.2,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M216.8,136.2c0,50-37.9,88.9-88,88.9C78.8,225.1,43,179.9,46,136c3.1-43.9,35.6-80.3,85.6-80.3 C181.7,55.6,216.8,86.1,216.8,136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M216.5,135.7c0,49.7-37.5,88.6-87.2,88.6c-49.7,0-85.4-44.3-82.5-88.2c2.9-43.9,35.6-80.3,85.3-80.3 C181.7,55.9,216.5,86.1,216.5,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M216.1,135.3c0,49.3-37.2,88.3-86.5,88.3c-49.3,0-84.9-43.4-82.2-87.2c2.8-43.8,35.5-80.2,84.9-80.2 C181.6,56.2,216.1,86,216.1,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M215.7,134.9c0,49-36.8,88.1-85.8,88.1c-49,0-84.4-42.6-81.8-86.3c2.6-43.7,35.5-80.1,84.5-80.1 C181.6,56.5,215.7,85.9,215.7,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M215.4,134.4c0,48.6-36.5,87.8-85.1,87.8c-48.6,0-83.9-41.7-81.5-85.4c2.5-43.7,35.5-80,84.1-80 C181.6,56.8,215.4,85.8,215.4,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M215,134c0,48.2-36.1,87.5-84.4,87.5c-48.2,0-83.4-40.8-81.1-84.4c2.3-43.6,35.5-79.9,83.7-79.9 C181.5,57.1,215,85.7,215,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M214.7,133.5c0,47.9-35.8,87.2-83.6,87.2c-47.9,0-83-40-80.8-83.5c2.2-43.5,35.5-79.8,83.4-79.8 C181.5,57.4,214.7,85.6,214.7,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M214.3,133.1c0,47.5-35.4,86.9-82.9,86.9c-47.5,0-82.5-39.1-80.4-82.5c2-43.4,35.5-79.7,83-79.7 C181.5,57.8,214.3,85.6,214.3,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M213.9,132.6c0,47.1-35,86.6-82.2,86.6c-47.1,0-82-38.2-80.1-81.6c1.9-43.4,35.5-79.6,82.6-79.6 C181.4,58.1,213.9,85.5,213.9,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M213.6,132.2c0,46.8-34.7,86.3-81.5,86.3c-46.8,0-81.5-37.4-79.7-80.7c1.7-43.3,35.4-79.5,82.2-79.5 C181.4,58.4,213.6,85.4,213.6,132.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M213.2,131.7c0,46.4-34.3,86.1-80.8,86.1c-46.4,0-81-36.5-79.4-79.7c1.6-43.2,35.4-79.4,81.9-79.4 C181.3,58.7,213.2,85.3,213.2,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M212.9,131.3c0,46.1-34,85.8-80,85.8c-46.1,0-80.5-35.6-79.1-78.8C55.2,95.1,89.2,59,135.2,59 C181.3,59,212.9,85.2,212.9,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M212.5,130.8c0,45.7-33.6,85.5-79.3,85.5c-45.7,0-80-34.7-78.7-77.8c1.3-43.1,35.4-79.2,81.1-79.2 C181.3,59.3,212.5,85.1,212.5,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M212.1,130.4c0,45.3-33.3,85.2-78.6,85.2c-45.3,0-79.5-33.9-78.4-76.9c1.2-43,35.4-79.1,80.7-79.1 S212.1,85.1,212.1,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M211.8,129.9c0,45-32.9,84.9-77.9,84.9c-45,0-79-33-78-75.9c1-42.9,35.4-79,80.3-79 C181.2,59.9,211.8,85,211.8,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M211.4,129.5c0,44.6-32.5,84.6-77.2,84.6c-44.6,0-78.5-32.1-77.7-75c0.9-42.9,35.4-79,80-79 C181.2,60.2,211.4,84.9,211.4,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M211,129c0,44.2-32.2,84.4-76.4,84.4c-44.2,0-78.1-31.3-77.3-74.1c0.7-42.8,35.3-78.9,79.6-78.9 C181.1,60.5,211,84.8,211,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M210.7,128.6c0,43.9-31.8,84.1-75.7,84.1c-43.9,0-77.6-30.4-77-73.1c0.6-42.7,35.3-78.8,79.2-78.8 C181.1,60.8,210.7,84.7,210.7,128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M210.3,128.2c0,43.5-31.5,83.8-75,83.8c-43.5,0-77.1-29.5-76.6-72.2c0.4-42.6,35.3-78.7,78.8-78.7 C181,61.1,210.3,84.6,210.3,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M210,127.7c0,43.2-31.1,83.5-74.3,83.5c-43.2,0-76.6-28.7-76.3-71.2c0.3-42.6,35.3-78.6,78.5-78.6 C181,61.4,210,84.6,210,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M209.6,127.3c0,42.8-30.8,83.2-73.6,83.2c-42.8,0-76.1-27.8-75.9-70.3c0.1-42.5,35.3-78.5,78.1-78.5 C181,61.7,209.6,84.5,209.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M209.2,126.8c0,42.4-30.4,82.9-72.8,82.9c-42.4,0-75.6-26.9-75.6-69.3C60.8,98,96.1,62,138.5,62 C180.9,62,209.2,84.4,209.2,126.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M220.4,135c0,47.2-38.3,85.5-85.4,85.5c-47.2,0-85.4-38.3-85.4-85.5c0-47.2,38.3-85.4,85.4-85.4 C182.2,49.6,220.4,87.8,220.4,135z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031887551965970338580000009923825408694654869_",
    gradientUnits: "userSpaceOnUse",
    x1: 5176.6978,
    y1: -8468.4863,
    x2: 5335.1982,
    y2: -8468.4863,
    gradientTransform: "matrix(-0.619 0.7854 -0.7854 -0.619 -3261.7119 -9236.4971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002702703,
    style: {
      stopColor: "#37A400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02621373,
    style: {
      stopColor: "#42AA0F",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08469747,
    style: {
      stopColor: "#58B52E",
      stopOpacity: 0.9173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    style: {
      stopColor: "#6BBF4A",
      stopOpacity: 0.8505
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    style: {
      stopColor: "#7BC760",
      stopOpacity: 0.7749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3134,
    style: {
      stopColor: "#87CD71",
      stopOpacity: 0.6868
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4216,
    style: {
      stopColor: "#8FD27C",
      stopOpacity: 0.5777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#94D483",
      stopOpacity: 0.4247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000031887551965970338580000009923825408694654869_)"
    },
    cx: 135.4,
    cy: 133.7,
    r: 79.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009554006856377751530000006136845853979076282_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.1393,
    y1: 133.6645,
    x2: 214.6462,
    y2: 133.6645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01117318,
    style: {
      stopColor: "#F79D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEC25"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000009554006856377751530000006136845853979076282_)"
    },
    cx: 135.4,
    cy: 133.7,
    r: 79.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M73.8,114.9c27.1-34.4,76.9-40.3,111.3-13.2c12.8,10.1,21.6,23.3,26.3,37.7c2.4-24.8-7.5-50.2-28.5-66.8 c-32.8-25.9-80.5-20.3-106.4,12.6c-12.6,15.9-17.7,35.4-15.9,54.1C63.5,130.7,67.9,122.4,73.8,114.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M195.4,179.3c-25.9,32.8-73.4,38.5-106.3,12.6c-16.8-13.3-26.5-32.2-28.4-52c1,20.7,10.7,41,28.3,54.8 c32.3,25.5,79.2,19.9,104.7-12.4c2.5-3.2,4.7-6.5,6.6-9.9C198.7,174.7,197.1,177,195.4,179.3z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,130.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1 C146.1,135.1,141.1,130.2,135,130.2L135,130.2z M135,130.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1 C146.1,135.1,141.1,130.2,135,130.2L135,130.2z M135,122.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.4,103.8h-9.4l-3.1-6.2c-1.8-3.6-2.8-6.2-6.2-6.2h-37.4c-3.4,0-4.6,3-6.2,6.2l-3.1,6.2h-9.4 c-6.9,0-12.5,5.6-12.5,12.5v49.9c0,6.9,5.6,12.5,12.5,12.5h74.8c6.9,0,12.5-5.6,12.5-12.5v-49.9 C184.9,109.4,179.3,103.8,172.4,103.8z M135,166.2c-13.8,0-24.9-11.2-24.9-24.9c0-13.8,11.2-24.9,24.9-24.9 c13.8,0,24.9,11.2,24.9,24.9C159.9,155,148.8,166.2,135,166.2z M172.9,123.7c-3.1,0-5.5-2.5-5.5-5.5c0-3.1,2.5-5.5,5.5-5.5 c3.1,0,5.5,2.5,5.5,5.5C178.4,121.3,175.9,123.7,172.9,123.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFotocam);
export default __webpack_public_path__ + "static/media/button-fotocam.b2552f745da5db3de36e4ef70ec054af.svg";
export { ForwardRef as ReactComponent };